/** */
export class Roles {

    public static readonly fullAccess = 'FullAccess';
    public static readonly manager = 'Manager';

}
